/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum UserTableFilterColumnEnum {
    IDENTIFICATION = 'IDENTIFICATION',
    ROLE = 'ROLE',
    PARTNER = 'PARTNER',
    TECHNICIAN = 'TECHNICIAN',
    SUPPLYING_PACKING_PLANT = 'SUPPLYING_PACKING_PLANT',
    SUPPLIER = 'SUPPLIER',
    CUSTOMER = 'CUSTOMER'
}
